import React, {useState} from 'react';
import {Button, Card, Divider, Grid, Typography} from "@mui/material";
import {SketchPicker} from "react-color";
import PageHeader from "./page-header";
import ColorPicker from "../../utils/color-picker";
import {useAppSettings} from "../../hooks/use-app-settings";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";

const UserSettings = () => {

    const appSettings = useAppSettings();
    const navigate = useNavigate();
    // Modal actions
    const [showColorPicker, setShowColorPicker] = useState(false);
    const handleColorPicker = () => {setShowColorPicker(true)}
    const handleColorPickerClose = () => {setShowColorPicker(false)}

    const [navbarColor, setnavBarColor] = useState(appSettings.get_navbar_color());

    const handleColorPick = (color) => {
        setnavBarColor(color);
        appSettings.set_navbar_color(color);
        navigate('/dashboard/settings')
    }

    return (
        <Grid container className="container-width">
            <ColorPicker onColorPick={handleColorPick} isShow={showColorPicker} onHandleClose={handleColorPickerClose} />
            <Grid item xs={12}>
                <PageHeader />
            </Grid>
            <Grid item xs={12} sx={{mx:2}}>
                    <Grid container>

                        <Grid item xs={6} >
                            <Typography variant="h6" gutterBottom component="div">
                                App Settings
                            </Typography>
                            <Divider />

                            <Grid container sx={{py:2}}>
                                <Grid item xs={4} >
                                    <Typography variant="subtitle2" gutterBottom component="div"> Pick a nav bar color </Typography>
                                </Grid>
                                <Grid item xs={4} >
                                    <Grid item sx={{background:navbarColor, width:"50px", p:1}}></Grid>
                                </Grid>
                                <Grid item xs={4} >
                                    <Button onClick={handleColorPicker} sx={{display:'block'}} variant={"outlined"}>Pick color</Button>
                                </Grid>
                            </Grid>


                        </Grid>

                    </Grid>
            </Grid>




        </Grid>
    );
};

export default UserSettings;
